import { useFetchReceivableInvoice } from 'receivable-invoices-js/react/api/queries/fetch-receivable-invoice/fetch-receivable-invoice';
import { useFetchReferralUrl } from 'receivable-invoices-js/react/api/queries/fetch-referral-url';

export function useRouteQuery(id: string) {
  const { data: invoice } = useFetchReceivableInvoice({ id });

  const { data: referralUrl } = useFetchReferralUrl({
    organizationId: invoice?.organization.id,
  });

  return { invoice, referralUrl };
}
